import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const GOLD = '#D4AF37';
const GOLD2 = '#f5c842';
const BG = '#050810';
const BG_CARD = '#0d1117';
const BORDER = 'rgba(255,255,255,0.07)';
const TEXT_SEC = '#6b7280';

const inputStyle = {
  width: '100%',
  background: '#0a0f1e',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 10,
  padding: '14px 16px',
  color: '#fff',
  fontSize: 15,
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
};

const labelStyle = {
  display: 'block',
  color: TEXT_SEC,
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 8,
};

export default function JoinWaitlist() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', service_id: '', preferred_date: '' });
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    api.get('/services').then(r => setServices(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) { setError('Name is required.'); return; }
    if (!form.phone) { setError('Phone number is required.'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/waitlist', {
        client_name: form.name,
        phone: form.phone,
        email: form.email || null,
        service_id: form.service_id || null,
        preferred_date: form.preferred_date || null,
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: BG, color: '#fff', fontFamily: 'inherit', display: 'flex', flexDirection: 'column' }}>
      <style>{`
        .wl-input:focus { border-color: rgba(212,175,55,0.5) !important; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        .wl-fade { animation: fadeUp 0.4s ease forwards; }
      `}</style>

      {/* Nav */}
      <div style={{ borderBottom: `1px solid ${BORDER}`, padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(5,8,16,0.95)', backdropFilter: 'blur(12px)', position: 'sticky', top: 0, zIndex: 100 }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <span style={{ fontSize: 20, fontWeight: 900, background: `linear-gradient(135deg, ${GOLD}, ${GOLD2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: '0.1em' }}>MANE</span>
        </Link>
        <Link to="/book" style={{ color: GOLD, fontSize: 13, fontWeight: 700, textDecoration: 'none', background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.25)', borderRadius: 8, padding: '8px 14px' }}>
          Try Booking →
        </Link>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 24px' }}>
        {submitted ? (
          <div className="wl-fade" style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
            <div style={{
              width: 80, height: 80, borderRadius: '50%',
              background: 'rgba(212,175,55,0.1)', border: '2px solid rgba(212,175,55,0.4)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 28px', fontSize: 36,
            }}><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18"/></svg></div>
            <h1 style={{
              fontSize: 32, fontWeight: 900, marginBottom: 16,
              background: `linear-gradient(135deg, ${GOLD}, ${GOLD2})`,
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>You're on the list!</h1>
            <p style={{ color: TEXT_SEC, fontSize: 17, lineHeight: 1.7, marginBottom: 40 }}>
              We'll be in touch the moment a spot opens up.<br />
              Sit tight — your fresh cut is coming.
            </p>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/book" style={{
                background: `linear-gradient(135deg, ${GOLD}, ${GOLD2})`, color: '#000',
                borderRadius: 10, padding: '14px 28px', fontWeight: 800, fontSize: 14,
                textDecoration: 'none', display: 'inline-block',
              }}>
                Try Booking Again
              </Link>
              <Link to="/" style={{
                background: 'transparent', color: TEXT_SEC,
                border: `1px solid ${BORDER}`, borderRadius: 10, padding: '14px 28px',
                fontWeight: 700, fontSize: 14, textDecoration: 'none', display: 'inline-block',
              }}>
                Back Home
              </Link>
            </div>
          </div>
        ) : (
          <div className="wl-fade" style={{ maxWidth: 520, width: '100%' }}>
            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.2)',
                borderRadius: 20, padding: '6px 16px', marginBottom: 24,
              }}>
                <span style={{ fontSize: 12, color: GOLD }}>·</span>
                <span style={{ color: GOLD, fontSize: 12, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Waitlist</span>
              </div>
              <h1 style={{ fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 900, lineHeight: 1.1, margin: '0 0 16px', letterSpacing: '-0.02em' }}>
                Join the{' '}
                <span style={{ background: `linear-gradient(135deg, ${GOLD}, ${GOLD2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  Waitlist
                </span>
              </h1>
              <p style={{ color: TEXT_SEC, fontSize: 16, lineHeight: 1.7 }}>
                We'll reach out the moment a spot opens up.
              </p>
            </div>

            {/* Form */}
            <div style={{ background: BG_CARD, border: `1px solid ${BORDER}`, borderRadius: 20, padding: '32px 28px' }}>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div>
                    <label style={labelStyle}>Your Name *</label>
                    <input
                      required
                      className="wl-input"
                      value={form.name}
                      onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                      placeholder="John Smith"
                      style={inputStyle}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Phone *</label>
                    <input
                      required
                      className="wl-input"
                      value={form.phone}
                      onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
                      placeholder="(561) 555-0100"
                      style={inputStyle}
                    />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Email <span style={{ color: '#1f2937', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
                  <input
                    type="email"
                    className="wl-input"
                    value={form.email}
                    onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                    placeholder="john@example.com"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Preferred Service</label>
                  <select
                    className="wl-input"
                    value={form.service_id}
                    onChange={e => setForm(f => ({ ...f, service_id: e.target.value }))}
                    style={{ ...inputStyle, appearance: 'none', backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%236b7280' fill='none' strokeWidth='1.5'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 14px center' }}
                  >
                    <option value="">Any service</option>
                    {services.map(s => (
                      <option key={s.id} value={s.id}>{s.name} — ${parseFloat(s.price).toFixed(0)}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label style={labelStyle}>Preferred Date</label>
                  <input
                    type="date"
                    className="wl-input"
                    value={form.preferred_date}
                    onChange={e => setForm(f => ({ ...f, preferred_date: e.target.value }))}
                    min={new Date().toISOString().split('T')[0]}
                    style={inputStyle}
                  />
                </div>

                {error && (
                  <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 10, padding: '12px 16px', color: '#ef4444', fontSize: 14 }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    background: loading ? '#1a1a1a' : `linear-gradient(135deg, ${GOLD}, ${GOLD2})`,
                    color: loading ? '#374151' : '#000',
                    border: 'none', borderRadius: 12,
                    padding: '16px', fontWeight: 800, fontSize: 15,
                    cursor: loading ? 'not-allowed' : 'pointer',
                    marginTop: 4,
                    letterSpacing: '0.02em',
                  }}
                >
                  {loading ? 'Submitting…' : 'Join the Waitlist →'}
                </button>
              </form>
            </div>

            <p style={{ color: '#1f2937', fontSize: 12, textAlign: 'center', marginTop: 20 }}>
              No spam. We'll only reach out when a spot becomes available.
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={{ borderTop: `1px solid ${BORDER}`, padding: '20px 24px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: 16, fontWeight: 900, letterSpacing: '0.12em', background: `linear-gradient(135deg, ${GOLD}, ${GOLD2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>MANE</span>
          <Link to="/book" style={{ color: TEXT_SEC, fontSize: 13, textDecoration: 'none' }}>Book</Link>
          <Link to="/gift" style={{ color: TEXT_SEC, fontSize: 13, textDecoration: 'none' }}>Gift Cards</Link>
          <Link to="/privacy" style={{ color: TEXT_SEC, fontSize: 13, textDecoration: 'none' }}>Privacy</Link>
        </div>
      </div>
    </div>
  );
}
